import { useState } from "react"

import { Button } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { AsanaWorkspaceSelect } from "@/pages/IntegrationsPage/components/molecules/AsanaWorkspaceSelect"
import { useAsanaSignIn } from "@/pages/IntegrationsPage/hooks/useAsanaSignIn"

import styles from "./AsanaWorkspaceChoice.module.scss"

import type { AsanaWorkspaceChoiceProps } from "./AsanaWorkspaceChoice.types"

export const AsanaWorkspaceChoice = ({
  workspaces,
  children
}: AsanaWorkspaceChoiceProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.asana.form.workspace"
  })
  const { t: tRoot } = useTranslation()
  const [workspaceGid, setWorkspaceGid] = useState<string>()
  const { signIn, isPending } = useAsanaSignIn()

  return (
    <div className={styles.container}>
      <AsanaWorkspaceSelect
        aria-label={t("label")}
        workspaces={workspaces}
        value={workspaceGid}
        onChange={setWorkspaceGid}
      />
      <div className={styles.actions}>
        <Button
          type="primary"
          disabled={!workspaceGid}
          loading={isPending}
          onClick={() => signIn(workspaceGid)}
        >
          {tRoot("general.continue")}
        </Button>
        {children}
      </div>
    </div>
  )
}
